import React from "react";
import { motion } from "framer-motion";

const shots = [
  {
    src: "/brand/product-keychain.png",
    tag: "On your keys",
    caption: "Clips onto the things you carry every day.",
  },
  {
    src: "/brand/product-phone.png",
    tag: "In your moment",
    caption: "A calm companion ready the second you call.",
  },
  {
    src: "/brand/product-card.png",
    tag: "By design",
    caption: "Crafted to feel premium from the first unbox.",
  },
];

const Showcase = () => {
  return (
    <section
      id="showcase"
      data-testid="showcase-section"
      className="relative py-28 md:py-36 bg-[#0A0A0A] text-white overflow-hidden"
    >
      <div className="absolute inset-0 opacity-30 pointer-events-none">
        <div className="absolute top-0 right-10 w-[500px] h-[500px] bg-blue-600/20 blur-[120px] rounded-full" />
      </div>

      <div className="relative mx-auto max-w-7xl px-6">
        <div className="max-w-2xl">
          <p className="text-xs tracking-[0.22em] uppercase text-blue-300/80 font-medium">In The Wild</p>
          <h2 className="mt-3 font-display text-4xl md:text-5xl lg:text-[56px] font-semibold tracking-[-0.02em] leading-[1.02]">
            Quietly <span className="italic font-light text-zinc-400">everywhere</span> you already are.
          </h2>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-5">
          {shots.map((s, i) => (
            <motion.figure
              key={s.src}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`showcase-${i}`}
              className="group relative rounded-3xl overflow-hidden border border-white/10 bg-black"
            >
              <div className="aspect-[4/5] overflow-hidden bg-[#0A0A0A]">
                <img
                  src={s.src}
                  alt={s.tag}
                  loading="lazy"
                  className="w-full h-full object-cover object-top transition-transform duration-[1200ms] ease-out group-hover:scale-[1.04]"
                />
              </div>
              <figcaption className="absolute inset-x-0 bottom-0 p-6 bg-gradient-to-t from-black/90 via-black/40 to-transparent">
                <div className="text-[10px] tracking-[0.22em] uppercase text-blue-300">{s.tag}</div>
                <div className="mt-1 font-display text-lg md:text-xl tracking-tight">{s.caption}</div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Showcase;
